import { Box, Typography } from '@mui/material';
import CountUp from 'react-countup';

const CounterCard = ({
    color = 'info',
    title = 'Titre',
    description = 'description',
    count = 0,
    duration = 2,
    delay = 0.5,
    suffix,
}) => {
    return (
        <Box p={2} textAlign={'center'} lineHeight={1}>
            <Typography variant='h3' color={color} className={'gradient_text'}>
                <CountUp
                    end={count}
                    duration={duration}
                    suffix={suffix || ''}
                    delay={delay}
                />
            </Typography>
            <Typography variant='h5' mt={2} mb={1}>
                {title}
            </Typography>
            <Typography variant='body2' color='text'>
                {description}
            </Typography>
        </Box>
    );
};

export default CounterCard;
